import { METHOD_GET } from 'api/constants/methods'
import { namespaceFetchWrapper as nsfw } from '.'

const suffix = 'categories'

export const getCategories = (query_params = {}) =>
  nsfw(METHOD_GET, suffix, query_params)

export const getCategoryBySlug = (slug, query_params = {}) =>
  nsfw(METHOD_GET, `${suffix}/${slug}`, query_params)

export const getParentCategories = (query_params = {}) =>
  nsfw(METHOD_GET, `${suffix}/parent`, query_params)
